import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-106" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-107" data-mp="4lyx6rdz8oga">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-108" data-mp="4njqkdok21ck">
          Solve a Full Year of English Class in Just{' '}
          <span className="italic text-brand" data-id="element-109" data-mp="ncq4lneem4s1">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-110" data-mp="3d1a8hk3o4bda">
          Join 2,000+ English teachers who stopped improvising. Walk into every
          class with everything ready to teach, speak, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-111" data-mp="399jnrenosh6n">
          <img src="https://cdn.magicpatterns.com/uploads/knFxNTsYwRtnyE8ryrCnV7/cf2b0fec-b912-4d5f-b976-44102fdaab5e.webp" alt="The ESL READY pack shown across six printed volumes, desktop, tablet and phone" className="w-full" data-id="element-112" data-mp="358ho4wpuy345" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="-mt-2 sm:mt-8" data-id="element-113" data-mp="2hjf7ns6ymgb8">
          <CtaButton href="#offer" data-id="element-114" data-mp="s2b73w324f43" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-115" data-mp="s3cmudv0pps5">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-116" data-mp="icromrj9an9r" data-mpi={index}>
                <span data-id="element-117" data-mp="ddwwgyzefmcz">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-118" data-mp="1b1fg54ulm8vr">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}